import { useQuery } from '@apollo/client/react';
import { MAPKIT_TOKEN_QUERY } from 'src/graphql/mapkit-queries';

export default function useGetMapkitToken() {
    const { data, loading } = useQuery(MAPKIT_TOKEN_QUERY);
    return { mapkitToken: data?.mapkitToken, loading };
}
